var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._b({},'span',_vm.$attrs,false),[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return [_c('a',_vm._b({class:{
				'text-decoration-underline': hover,
				'text-decoration-none': !hover
			},on:{"click":function($event){return _vm.$emit('click')}}},"a",_vm._d({},[_vm.HREFAttribute,_vm.href])),[_vm._t("default",function(){return [_vm._v("My Link")]})],2)]}}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }